require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// /opt/yplan/npm_env_auth_timeout/~/babel-polyfill/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 832
// module chunks = 0